import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { API_ROUTE, Routes } from "../Helpers/Constants";
import Axios from "axios";
import ReactQuill from "react-quill";
import { toast } from 'react-toastify';
import "react-quill/dist/quill.snow.css";

const NotificationModal = ({ isOpen, toggle }) => {
    const [rowData, setRowData] = useState([]);
    const [editedRow, setEditedRow] = useState([]);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [message, setMessage] = useState("");
    const urlParams = new URLSearchParams(window.location.search);
    const handleCheckboxChange = (params, event) => {
        const updatedData = [...rowData];
        updatedData[params.node.rowIndex].enabled = event.target.checked;
        setRowData(updatedData);
        const newEditedRow = [...editedRow];
        const editedRowIndex = newEditedRow.findIndex((row) => row.order === params.data.order);
        if (editedRowIndex >= 0) {
            newEditedRow[editedRowIndex] = { ...params.data, enabled: event.target.checked };
        } else {
            newEditedRow.push({ ...params.data, enabled: event.target.checked });
        }
        setEditedRow(newEditedRow);
    };
    const onCellValueChanged = (params) => {
        const updatedData = [...rowData];
        updatedData[params.node.rowIndex][params.column.colId] = params.newValue;
        let updatedText = params.newValue.trim();

        updatedText = updatedText.trim();
        if (params.column.colId === "message") {
            const formattedText = updatedText 
                .split(". ")
                .map((line) => `<p>${line.trim()}</p>`)
                .join("<br/>");

            params.data.message = `<div>${formattedText}</div>`;
        }
        setRowData(updatedData);
        const newEditedRow = [...editedRow];
        const editedRowIndex = newEditedRow.findIndex((row) => row.order === params.data.order);
        if (editedRowIndex >= 0) {
            newEditedRow[editedRowIndex] = params.data;
        } else {
            newEditedRow.push(params.data);
        }

        setEditedRow(newEditedRow);
    };

    const handleEditClick = (params) => {
        setSelectedRow(params.data);

        let formattedMessage = params.data.message || "";
        formattedMessage = formattedMessage
            .replace(/<\/p>\s*<p>/g, "</p><p>")  // Ensure paragraphs are correctly spaced
            .replace(/(<p><br\s*\/?><\/p>)+/g, "<p><br/></p>"); // Remove excessive empty paragraph tags
        setMessage(formattedMessage);
        setEditModalOpen(true);
    };

    const handleSaveMessage = () => {
        if (selectedRow) {
            const updatedData = rowData.map((row) =>
                row.order === selectedRow.order ? { ...row, message } : row
            );
            setRowData(updatedData);

            // Track edited row
            const newEditedRow = editedRow.filter((row) => row.order !== selectedRow.order);
            newEditedRow.push({ ...selectedRow, message });
            setEditedRow(newEditedRow);
        }
        setEditModalOpen(false);
    };

    const columnDefs = [
        {
            headerName: "Edit",
            field: "order",
            width: 70,
            resizable:true,
            cellRenderer: (params) => (
                <button
                    style={{ cursor: "pointer", padding: "5px 10px", background: "transparent", border: "none" }}
                    onClick={() => handleEditClick(params)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="16"
                        fill="currentColor"
                        className="bi bi-pencil-square"
                        viewBox="0 0 16 16"
                    >
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path
                            fillRule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                        />
                    </svg>
                </button>
            ),
        },
        //{
        //    headerName: "Order", field: "order", sortable: true, filter: true, resizable: true, width: 100
        //},
        {
            headerName: "Message", field: "message", flex: 1, resizable: true, sortable: true, filter: true,
            editable: false,
            valueGetter: (params) => {
                const message = params.data.message;
                if (message) {
                    // Strip HTML tags and display the plain text in the grid
                    return message.replace(/<\/?[^>]+(>|$)/g, "");
                }
                return "";
            },
            cellRenderer: (params) => { 
                 const message = params.value
                    ?.replace(/<\/?[^>]+(>|$)/g, " ") // Remove HTML tags
                    .replace(/^\s+|\s+$/g, "")
                    .replace(/\s+/g, " "); // Remove extra spaces
                return <div>{message}</div>
            },

        },
        {
            headerName: "Enable", field: "enabled", sortable: true, filter: true, editable: false, resizable: true, width: 100,
            cellRenderer: (params) => (
                <input
                    type="checkbox"
                    checked={params.value || false}
                    onChange={(e) => handleCheckboxChange(params, e)}
                    style={{ cursor: "pointer"}}
                />
            ),
        },

    ];
    useEffect(() => {
        if (isOpen) {
            showNotifications();
        }
    }, [isOpen]);

    const showNotifications = async () => {
        const config = {
            headers: {
                Authorisation: `Bearer NOT REQUIRED`,
            },
        };
        let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
        await Axios.get(API_ROUTE + Routes.GET_NOTIFICATIONS(orgId, true), config)
            .then((response) => {
                let data = JSON.parse(response.data).map((item) => {
                    return item;
                });

                setRowData(data);
            })
            .catch((reason) => {
                console.log("Error in showNotifications: " + reason);
            });
    }
    const editNotifications = async () => {
        const rowsToUpdate = editedRow.map((row) => {
            row.enabled = row.enabled === "true" ? true : row.enabled === "false" ? false : row.enabled;
            return row;
        });
        const config = {
            headers: {
                Authorisation: `Bearer NOT REQUIRED`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        try {
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            const response = await Axios.put(API_ROUTE + Routes.UPDATE_NOTIFICATIONS(orgId), rowsToUpdate, config);

            if (response.status === 200) {
                setEditedRow([]);
                toast.success("Edit updated successfully");
            } else {
                console.log("Failed to update notifications. Status:", response.status);
            }
            toggle();
        } catch (error) {
            console.log("Error updating notifications:", error);
        }
    };

    return (
        <>
            <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
            <ModalHeader>
                <span style={{ fontSize: "20px" }}>Manage Notifications</span>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    style={{ transform: 'scale(0.75)', position: "absolute", right: "20px", top: "22px" }}
                    onClick={toggle}>
                </button>
            </ModalHeader>

            <ModalBody>
                <div className="ag-theme-alpine" style={{ height: 350 }}>
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10,20, 50]}
                        domLayout="normal"
                        onCellValueChanged={onCellValueChanged}  // Track changes
                        rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                        
                    />
                </div>
                <div className="d-flex justify-content-end mt-3">
                    <button onClick={toggle} className="btn btn-secondary me-2">
                        Cancel
                    </button>
                    <button onClick={editNotifications} className="btn btn-primary ">
                        Save
                    </button>
                </div>
            </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} size="lg" toggle={() => setEditModalOpen(false)} backdrop="static">
            <ModalHeader>Edit Message</ModalHeader>
            <ModalBody style={{ height: 350 }}>
                <ReactQuill   value={message} style={{ height:"80%" }} onChange={setMessage} theme="snow" />
            </ModalBody>
            <ModalFooter>
                <button onClick={() => setEditModalOpen(false)} className="btn btn-secondary">Cancel</button>
                <button onClick={handleSaveMessage} className="btn btn-primary">Save</button>
            </ModalFooter>
        </Modal>
        </>
    );
};

export default NotificationModal;
